export const STATUS = {
  da_assegnare: { label: "Da assegnare", cls: "bg-amber-100 text-amber-800 border-amber-200" },
  assegnato: { label: "Assegnato", cls: "bg-sky-100 text-sky-800 border-sky-200" },
  preso_in_carico: { label: "Preso in carico", cls: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  in_lavorazione: { label: "In lavorazione", cls: "bg-lime-100 text-lime-800 border-lime-200" },
  sospeso: { label: "Sospeso", cls: "bg-slate-200 text-slate-700 border-slate-300" },
  completato: { label: "Da verificare", cls: "bg-orange-100 text-orange-800 border-orange-200" },
  chiuso: { label: "Chiuso e verificato", cls: "bg-emerald-100 text-emerald-800 border-emerald-200" },
  riaperto: { label: "Riaperto", cls: "bg-rose-100 text-rose-800 border-rose-200" },
  annullato: { label: "Annullato", cls: "bg-zinc-100 text-zinc-500 border-zinc-200 line-through" },
};

export const PRIORITY = {
  normale: { label: "Normale", cls: "bg-sky-50 text-sky-800 border-sky-200" },
  alta: { label: "Alta", cls: "bg-red-100 text-red-800 border-red-300 font-bold" },
};

export const IMPEDIMENTS = {
  nessuno: "Ritardo senza impedimento",
  materiale: "Mancanza di materiale",
  mezzo: "Guasto del mezzo",
  personale: "Assenza di personale",
  meteo: "Condizioni meteorologiche",
  autorizzazione: "Necessità di autorizzazione",
  altro: "Altro impedimento",
};

export const ROLE_LABEL = {
  ceo: "CEO", amministrazione: "Amministrazione", responsabile: "Responsabile di commessa",
  caposquadra: "Caposquadra", operatore: "Operatore", manutenzione: "Manutenzione mezzi",
  sicurezza: "Sicurezza", qualita: "Controllo qualità",
};

const dtf = new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" });
const df = new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "short", year: "numeric" });

export const fmtDT = (v) => (v ? dtf.format(new Date(v)) : "—");
export const fmtD = (v) => (v ? df.format(new Date(v)) : "—");
export const fmtWhen = (o) => (o.due_current ? fmtDT(o.due_current) : o.work_date ? `Data ${fmtD(`${o.work_date}T12:00:00`)}` : "—");

export function lateness(due) {
  const h = (Date.now() - new Date(due).getTime()) / 3600000;
  const abs = Math.abs(h);
  const txt = abs >= 48 ? `${Math.floor(abs / 24)} giorni` : `${Math.max(1, Math.floor(abs))} ore`;
  return h > 0 ? `scaduto da ${txt}` : `scade tra ${txt}`;
}

export const toLocalInput = (d) => {
  const x = new Date(d);
  x.setMinutes(x.getMinutes() - x.getTimezoneOffset());
  return x.toISOString().slice(0, 16);
};

export const MANAGER_ROLES = ["ceo", "responsabile"];
